import{T as a,g as m,D as o,t}from"./common-5e0be57a.mjs";const s=a,e={...m().Intl,DateTimeFormat:o},r=t;export{e as Intl,s as Temporal,r as toTemporalInstant};
//# sourceMappingURL=impl.mjs.map
